import ArticleLayout from '@/components/feature/ArticleLayout';
import { ArticleSchema, BreadcrumbListSchema } from '@/components/base/SchemaOrg';

const article = {
  date: '10. Juli 2026',
  updatedDate: '16. Juli 2026',
  readingTime: '6 Min.',
  title: 'OOPBuy Spreadsheet Jacken 2026: Beste Jacken & Mäntel',
  subtitle: 'Entdecke Top-Jacken im OOPBuy Spreadsheet. Von Bomberjacken über Wintermäntel bis Designer-inspiriert – mit QC-Guide.',
  author: 'OOPBuy Redaktionsteam',
  heroImageUrl: "https://readdy.ai/api/search-image?query=Variety%20of%20premium%20jackets%20and%20coats%20hanging%20on%20wooden%20hangers%20against%20textured%20concrete%20wall%2C%20soft%20directional%20lighting%2C%20autumn%20fashion%20aesthetic%2C%20leather%20bomber%2C%20wool%20coat%2C%20and%20denim%20jacket%20displayed%2C%20warm%20amber%20and%20charcoal%20tones%2C%20editorial%20fashion%20photography&width=1600&height=900&seq=hero-jacken-u3&orientation=landscape",
  tableOfContents: [
    { id: 'section-1', label: 'Jacken im OOPBuy Spreadsheet' },
    { id: 'section-2', label: 'Jacken-Typen im Vergleich' },
    { id: 'section-3', label: 'QC für Jacken' },
    { id: 'section-4', label: 'Beste Jacken-Verkäufer' },
    { id: 'section-5', label: 'Fazit' },
  ],
};

const relatedArticles = [
  { title: 'OOPBuy Spreadsheet Guide', desc: 'Der komplette Leitfaden', link: '/artikel/oopbuy-spreadsheet-guide', isReady: true },
  { title: 'OOPBuy Spreadsheet Hoodie', desc: 'Die besten Hoodies & Pullover', link: '/artikel/oopbuy-spreadsheet-hoodie', isReady: true },
  { title: 'OOPBuy Versand Guide', desc: 'Alles zu Versand & Lieferung', link: '/artikel/oopbuy-versand-guide', isReady: true },
];

export default function JackenPage() {
  return (
    <ArticleLayout article={article} relatedArticles={relatedArticles}>
      <ArticleSchema
        headline={article.title}
        description={article.subtitle}
        image={article.heroImageUrl}
        datePublished="2026-07-10"
        dateModified="2026-07-16"
        authorName={article.author}
        url="https://oopbuyspread.buzz/artikel/oopbuy-spreadsheet-jacken"
      />
      <BreadcrumbListSchema items={[
        { name: 'Startseite', item: 'https://oopbuyspread.buzz/' },
        { name: 'OOPBuy Spreadsheet Jacken', item: 'https://oopbuyspread.buzz/artikel/oopbuy-spreadsheet-jacken' },
      ]} />
      <section id="section-1">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Jacken im OOPBuy Spreadsheet</h2>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
          Mit rund 280 gelisteten Jacken ist diese Kategorie eine der vielfältigsten im <strong>OOPBuy Spreadsheet</strong>. Von leichten Übergangsjacken bis zu dicken Winterparkas – hier findest Du für jede Saison das passende Modell.
        </p>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
          Besonders die <strong>oopbuy spreadsheet deutschland</strong> Jacken-Kategorie punktet mit guten QC-Bewertungen. Reißverschlüsse, Futter und Wasserdichtigkeit werden von der Community genau geprüft.
        </p>
      </section>

      <section id="section-2">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Jacken-Typen im Vergleich</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200">
                <th className="text-left py-3 px-3 text-foreground-800 font-semibold">Typ</th>
                <th className="text-left py-3 px-3 text-foreground-800 font-semibold">Preis</th>
                <th className="text-left py-3 px-3 text-foreground-800 font-semibold">QC-Aufwand</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Bomberjacke', '€30-70', 'Mittel – Nähte & Reißverschlüsse prüfen'],
                ['Winterparka', '€50-120', 'Hoch – Füllung & Wasserdichtigkeit testen'],
                ['Denim Jacke', '€25-60', 'Niedrig – Materialstärke checken'],
                ['Lederjacke', '€60-150', 'Hoch – Echtes vs. Kunstleder prüfen'],
              ].map((row, idx) => (
                <tr key={idx} className="border-b border-background-100">
                  <td className="py-3 px-3 text-foreground-800 font-medium">{row[0]}</td>
                  <td className="py-3 px-3 text-foreground-500">{row[1]}</td>
                  <td className="py-3 px-3 text-foreground-500">{row[2]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section id="section-3">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">QC für Jacken</h2>
        <div className="bg-background-100 rounded-2xl p-5 md:p-6">
          <ul className="space-y-2">
            {[
              'Reißverschlüsse: Mehrmals öffnen und schließen lassen – auf den QC-Fotos prüfen',
              'Futter: Qualität und Befestigung des Innenfutters checken',
              'Nähte: Besonders an Schultern und Ärmeln auf Doppelnähte achten',
              'Material: Bei Lederjacken den Ledergeruch auf QC-Fotos nicht sichtbar – hier hilft Community-Feedback',
            ].map((item, idx) => (
              <li key={idx} className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-line text-accent-500 mt-0.5 flex-shrink-0"></i>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section id="section-4">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Beste Jacken-Verkäufer</h2>
        <div className="space-y-3">
          {[
            { name: 'PremiumFinds', note: 'Spezialist für hochwertige Jacken' },
            { name: 'TopSeller DE', note: 'Beste Allround-Auswahl' },
          ].map((s, idx) => (
            <div key={idx} className="flex items-center justify-between bg-white rounded-xl p-4 border border-background-200/70">
              <p className="font-semibold text-sm text-foreground-900">{s.name}</p>
              <p className="text-xs text-foreground-500">{s.note}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="section-5">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Fazit</h2>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
          Jacken aus dem <strong>OOPBuy Spreadsheet</strong> bieten exzellentes Preis-Leistungs-Verhältnis. Mit gründlicher QC-Prüfung – besonders bei Reißverschlüssen und Futter – machst Du keine Kompromisse bei der Qualität.
        </p>
      </section>
    </ArticleLayout>
  );
}